import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CircleManageProfileRoute extends DiscourseRoute {
  @service circles;

  showFooter = true;

  titleToken() {
    return i18n(`discourse_circles.circle.manage.profile.title_token`);
  }

  async beforeModel() {
    await this.circles.reloadCustomFields();
  }

  model() {
    return this.modelFor("circle");
  }
}
